<template>
  <b-button
    type="is-text"
    @click="toggleTheme"
    :title="theme === 'light' ? 'ダークモードに切り替え' : 'ライトモードに切り替え'"
    :aria-label="theme === 'light' ? 'ダークモードに切り替え' : 'ライトモードに切り替え'"
    class="theme-toggle-button"
    :class="{ 'has-text': showText }"
  >
    <b-icon :icon="theme === 'light' ? 'moon' : 'sun'" />
    <span v-if="showText" class="theme-toggle-text">
      {{ theme === 'light' ? 'ダークモード' : 'ライトモード' }}
    </span>
  </b-button>
</template>

<script>
import { useTheme } from '@/composables/useTheme'

export default {
  name: 'ThemeToggle',
  props: {
    showText: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { theme, toggleTheme } = useTheme()
    
    return {
      theme,
      toggleTheme
    }
  }
}
</script>

<style scoped>
.theme-toggle-button {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: var(--navbar-link-color) !important;
}

.theme-toggle-button.has-text {
  display: flex !important;
  align-items: center !important;
  gap: 0.75rem !important;
  width: 100% !important;
  padding: 0.875rem 1rem !important;
  background-color: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 8px !important;
  color: var(--text-color) !important;
  font-weight: 500 !important;
  justify-content: flex-start !important;
  transition: all 0.2s ease !important;
}

.theme-toggle-button.has-text:hover {
  background-color: var(--dropdown-item-hover) !important;
  border-color: var(--primary-color) !important;
  color: var(--text-color) !important;
}

.theme-toggle-button:hover {
  color: var(--navbar-link-hover-color) !important;
}

.theme-toggle-button.has-text:focus {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(242, 67, 104, 0.25) !important;
}

.theme-toggle-button:focus {
  box-shadow: none !important;
  color: var(--navbar-link-hover-color) !important;
}

.theme-toggle-text {
  flex: 1;
  text-align: left;
}
</style>